module.exports = __webpack_public_path__ + "img/scan.9735ecc9.png";